module.exports = __webpack_public_path__ + "static/media/emojis2_21.04482a63.svg";